import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
const navColumns = [{
  title: 'Компанія',
  links: [{
    label: 'Про нас',
    href: '/#about'
  }, {
    label: 'Послуги',
    href: '/#services'
  }, {
    label: 'Блог',
    href: '/blog',
    isRoute: true
  }, {
    label: 'Контакти',
    href: '/#contact'
  }]
}, {
  title: 'Послуги',
  links: [{
    label: 'Підбір персоналу',
    href: '/#services'
  }, {
    label: 'Аутсорсинг',
    href: '/#services'
  }, {
    label: 'HR‑адміністрування',
    href: '/#services'
  }, {
    label: 'Консалтинг',
    href: '/#services'
  }]
}, {
  title: 'Кандидатам',
  links: [{
    label: 'Вакансії',
    href: '/#niches'
  }, {
    label: 'Напрямки',
    href: '/#niches'
  }, {
    label: "Кар'єрні поради",
    href: '/blog',
    isRoute: true
  }]
}];
export function Footer() {
  return <footer className="bg-navy-900 text-white" data-id="element-221">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-222">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8" data-id="element-223">
          {/* Brand column */}
          <div className="lg:col-span-2" data-id="element-224">
            <Link to="/" className="flex items-center gap-2.5 mb-5" data-id="element-225">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-400 to-primary-600 flex items-center justify-center" data-id="element-226">
                <span className="text-white font-extrabold text-xs tracking-wider" data-id="element-227">
                  ESCA
                </span>
              </div>
              <div className="flex flex-col" data-id="element-228">
                <span className="font-extrabold text-lg tracking-tight leading-none" data-id="element-229">
                  ESCA
                </span>
                <span className="text-[9px] font-medium text-navy-400 tracking-widest uppercase leading-none mt-0.5" data-id="element-230">
                  Executive Search
                </span>
              </div>
            </Link>
            <p className="text-navy-400 text-sm leading-relaxed max-w-sm mb-6" data-id="element-231">
              Executive Search Consulting Agency. Допомагаємо бізнесу знаходити
              найкращих спеціалістів, а професіоналам — роботу мрії.
            </p>

            <div className="space-y-3" data-id="element-232">
              <div className="flex items-start gap-3 text-sm" data-id="element-233">
                <MapPinIcon className="w-4 h-4 text-primary-400 mt-0.5 flex-shrink-0" data-id="element-234" />
                <span className="text-navy-300" data-id="element-235">
                  м. Київ, вул. Хрещатик, 22, офіс 501
                </span>
              </div>
              <div className="flex items-center gap-3 text-sm" data-id="element-236">
                <PhoneIcon className="w-4 h-4 text-primary-400 flex-shrink-0" data-id="element-237" />
                <a href="tel:+380441234567" className="text-navy-300 hover:text-white transition-colors" data-id="element-238">
                  +38 (044) 123‑45‑67
                </a>
              </div>
              <div className="flex items-center gap-3 text-sm" data-id="element-239">
                <MailIcon className="w-4 h-4 text-primary-400 flex-shrink-0" data-id="element-240" />
                <a href="mailto:info@esca.ua" className="text-navy-300 hover:text-white transition-colors" data-id="element-241">
                  info@esca.ua
                </a>
              </div>
            </div>
          </div>

          {/* Nav columns */}
          {navColumns.map(col => <div key={col.title} data-id="element-242">
              <h3 className="font-semibold text-sm text-white mb-4" data-id="element-243">
                {col.title}
              </h3>
              <ul className="space-y-3" data-id="element-244">
                {col.links.map((link: any) => <li key={link.label} data-id="element-245">
                    {link.isRoute ? <Link to={link.href} className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-246">
                        {link.label}
                      </Link> : <a href={link.href} className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-247">
                        {link.label}
                      </a>}
                  </li>)}
              </ul>
            </div>)}
        </div>

        {/* Social + legal */}
        <div className="mt-14 pt-8 border-t border-navy-800 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-248">
          <p className="text-sm text-navy-500" data-id="element-249">
            © 2026 ESCA. Усі права захищені.
          </p>

          {/* Social icons */}
          <div className="flex items-center gap-3" data-id="element-250">
            <a href="#" className="w-9 h-9 rounded-lg bg-navy-800 flex items-center justify-center text-navy-400 hover:bg-primary-600 hover:text-white transition-all" aria-label="LinkedIn" data-id="element-251">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" data-id="element-252">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-253" />
              </svg>
            </a>
            <a href="#" className="w-9 h-9 rounded-lg bg-navy-800 flex items-center justify-center text-navy-400 hover:bg-primary-600 hover:text-white transition-all" aria-label="Facebook" data-id="element-254">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" data-id="element-255">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-256" />
              </svg>
            </a>
            <a href="#" className="w-9 h-9 rounded-lg bg-navy-800 flex items-center justify-center text-navy-400 hover:bg-primary-600 hover:text-white transition-all" aria-label="Instagram" data-id="element-257">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" data-id="element-258">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-259" />
              </svg>
            </a>
            <a href="https://t.me/esca_agency" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg bg-navy-800 flex items-center justify-center text-navy-400 hover:bg-[#229ED9] hover:text-white transition-all" aria-label="Telegram" data-id="element-260">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" data-id="element-261">
                <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0h-.056zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-262" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}